import { useCallback } from "react";

import { BookmarkIcon } from "lucide-react";

import { LabelChooser } from "simplydo/react/components/Choosers/LabelChooser/LabelChooser";
import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";

import api from "api";
import { useCurrentUser } from "utils/currentUser";
import util from "utils/utils";

import type { IdeaWithOwnerChallenge } from "../types";

type LabelActionProps = { idea: IdeaWithOwnerChallenge };

const LabelAction = ({ idea }: LabelActionProps) => {
  const user = useCurrentUser();

  const labelIdea = useCallback(
    (label: string, isApplied: boolean) => {
      let labels = idea.labels || [];
      if (labels.includes(label)) {
        if (!isApplied) {
          labels = labels.filter((l: string) => l !== label);
        }
      } else {
        if (isApplied) {
          labels = [...labels, label];
        }
      }

      api.ideas.updateStatus(
        idea._id,
        { labels },
        () => {
          util.onUpdateIdea(idea, { labels });
        },
        () => {},
      );
    },
    [idea],
  );

  if (
    !util.canManageChallenge(user!, idea.ownerChallenge) &&
    !util.hasPermission(user!, "challenge.editIdeaLabels", idea.challenge)
  ) {
    return null;
  }

  return (
    <LabelChooser
      challengeId={idea.challenge}
      onComplete={(em) => labelIdea(em, true)}
      existing={idea?.labels}
      onRemoveExisting={(em) => labelIdea(em, false)}
      trigger={
        <Button>
          <Icon icon={BookmarkIcon} />
        </Button>
      }
      tooltip="Label idea"
    />
  );
};

export default LabelAction;
